import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { Layout } from 'layouts';
import { withHuggg, withRedirect } from 'hoc';
import { useAnalytics, usePersistedState } from 'hooks';
import styles from './reveal.module.scss';
import { RevealCardContainer } from 'components/Reveal';
import { getBasePathname } from 'utilities/huggg';
import { getVouchers } from 'redux/modules/huggg';

export const ScreensReveal = (props) => {
  /**
   * Threshold at which a user us classes as "experienced" so then we toggle
   * interface elements on for them.
   *
   * @var {Integer} interfaceThreshold
   */
  const interfaceThreshold = 2;
  const { huggg } = props;
  const analytics = useAnalytics();
  const [viewedShortcodes, setViewedShortcodes] = usePersistedState(
    'viewedShortcodes',
    [],
  );

  useEffect(() => {
    const shortcode = huggg.shortcode;
    const shouldStore =
      !viewedShortcodes.includes(shortcode) &&
      viewedShortcodes.length <= interfaceThreshold;

    if (shouldStore) {
      setViewedShortcodes([...viewedShortcodes, shortcode]);
    }
  }, [analytics, huggg.shortcode, setViewedShortcodes, viewedShortcodes]);

  return (
    <Layout showBackButton={false} layout="reveal">
      <div
        className={classnames('container', styles.container)}
        data-test-id="reveal-wrapper"
      >
        <RevealCardContainer data-test-id="reveal-voucher" />
      </div>
    </Layout>
  );
};

ScreensReveal.propTypes = {
  huggg: PropTypes.object.isRequired,
  vouchers: PropTypes.array,
};

const urlVoucherRedirectHandler = (props) => {
  const voucher = props.vouchers?.[0];

  return [
    voucher?.type === 'url' && voucher?.value,
    `${getBasePathname(props.huggg)}/redeemed`,
  ];
};

const redirectHandler = (props) => {
  return [
    !props.isRedeemed && !props.isFetchedHuggg && !props.hasFulfilledVoucher,
    `${getBasePathname(props.huggg)}/redeem`,
  ];
};

const augmentedWithHuggg = (screen) => withHuggg(screen, { isReveal: true });

const mapStateToProps = (state) => ({
  vouchers: getVouchers(state),
});

export default compose(
  augmentedWithHuggg,
  connect(mapStateToProps),
  withRedirect(urlVoucherRedirectHandler),
  withRedirect(redirectHandler),
)(ScreensReveal);
